class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
  }

  connectedCallback() {
    this.hoverController = new AbortController();
    const signal = this.hoverController.signal;
    this.hoverQuery = matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');
    this.querySelectorAll('details details').forEach((details) => {
      const summary = details.querySelector(':scope > summary');
      let closeTimer;
      details.addEventListener('pointerenter', (event) => {
        if (!this.hoverQuery.matches || event.pointerType === 'touch') return;
        clearTimeout(closeTimer);
        details.open = true;
      }, { signal });
      details.addEventListener('pointerleave', () => {
        if (!this.hoverQuery.matches) return;
        clearTimeout(closeTimer);
        closeTimer = setTimeout(() => {
          if (!details.contains(document.activeElement)) details.open = false;
        }, 180);
      }, { signal });
      details.addEventListener('toggle', () => {
        summary.setAttribute('aria-expanded', String(details.open));
      }, { signal });
      signal.addEventListener('abort', () => clearTimeout(closeTimer), { once: true });
    });
    this.mainDetailsToggle.querySelector(':scope > summary').addEventListener('click', (event) => {
      const url = event.currentTarget.dataset.menuUrl;
      if (!url || !this.hoverQuery.matches || event.detail === 0) return;
      event.preventDefault();
      window.location.assign(url);
    }, { signal });
    this.addEventListener('pointerenter', (event) => {
      if (!this.hoverQuery.matches || event.pointerType === 'touch') return;
      clearTimeout(this.hoverCloseTimer);
      this.mainDetailsToggle.open = true;
    }, { signal });
    this.addEventListener('pointerleave', () => {
      if (!this.hoverQuery.matches) return;
      clearTimeout(this.hoverCloseTimer);
      this.hoverCloseTimer = setTimeout(() => {
        if (!this.contains(document.activeElement)) this.close();
      }, 180);
    }, { signal });
  }

  disconnectedCallback() {
    clearTimeout(this.hoverCloseTimer);
    this.hoverController?.abort();
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.contains(document.activeElement)) return;
      if (this.hoverQuery?.matches && this.matches(':hover')) return;
      this.close();
    });
  }

  onToggle() {
    const open = this.mainDetailsToggle.open;
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', String(open));
    if (open) {
      this.closest('.header__inline-menu')?.querySelectorAll('header-menu').forEach((menu) => {
        if (menu !== this) menu.close();
      });
    }
    if (!this.header) return;
    this.header.preventHide = Boolean(this.header.querySelector('header-menu details[open]'));

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
